import { Component } from '@angular/core';
import { ApartmentTypeDetailsBaseComponent } from './../common-theme/index';

@Component({
  selector: 'app-apartment-type-details',
  templateUrl: './apartment-type-details.component.html',
  styleUrls: ['./house-details.component.scss']
})

export class ApartmentTypeDetailsComponent extends ApartmentTypeDetailsBaseComponent {
  ngOnInit(): void {
    super.ngOnInit();
    const title = this.apartmentType.title.toLocaleLowerCase().replace(/(^\w{1})|(\s{1}\w{1})/g, match => match.toUpperCase());
    this.setTitle(title);
    this.setMetaDescription(`${title} - Tip apartament Dream Residence. ${this.apartmentType.description}`);
  }

  compareString(a: any, b: any): number {
    if (a.project.name < b.project.name)
      return -1;
    if (a.project.name > b.project.name)
      return 1;
    return 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/houses/apartment-type-details.component.ts